<template>
  <v-container fluid>
    <div class="mb-2">
      <div style="overflow-x: auto; white-space: nowrap">
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'today'"
          :color="currentFilter == 'today' ? 'primary' : 'grey'"
          small
          @click="changeDate('today')"
          >{{ $t('today') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'this_month'"
          :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
          small
          @click="changeDate('this_month')"
          >{{ $t('this month') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'this_year'"
          :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
          small
          @click="changeDate('this_year')"
          >{{ $t('this year') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'last_month'"
          :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
          small
          @click="changeDate('last_month')"
          >{{ $t('last 30 days') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'last_365_day'"
          :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
          small
          @click="changeDate('last_365_day')"
          >{{ $t('last 365 days') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'custom_date'"
          :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
          small
          @click="changeDate('custom_date')"
          >{{ $t('Custom Date') }}</v-btn
        >
      </div>
      <v-layout
        wrap
        class="mt-2"
        v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'"
      >
        <v-flex xs12 sm6>
          <span class="order_summary_datepicker">{{ $t('from') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex xs8 class="form-control">
              <datepicker v-model="selectedDate.start" @selected="onSelectedStartDate"></datepicker>
            </v-flex>
            <v-flex xs4 class="form-control">
              <v-dialog
                ref="starttime"
                v-model="showStartTimeDialog"
                :return-value.sync="starttime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="starttime" />
                  </div>
                </template>
                <v-time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showStartTimeDialog = false">
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.starttime.save(starttime)
                      showStartTimeDialog = false
                      changeDate('custom_time')
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6>
          <span class="order_summary_datepicker" style="margin-bottom: 10px;">{{ $t('to') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex xs8 class="form-control">
              <datepicker
                v-model="selectedDate.end"
                style
                @selected="onSelectedEndDate"
              ></datepicker>
            </v-flex>
            <v-flex xs4 class="form-control">
              <v-dialog
                ref="endtime"
                v-model="showEndTimeDialog"
                :return-value.sync="endtime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="endtime" />
                  </div>
                </template>
                <v-time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showEndTimeDialog = false">
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.endtime.save(endtime)
                      showEndTimeDialog = false
                      changeDate('custom_time')
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn color="primary" @click="loadSummary" small>
            {{ $t('Search') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <v-divider class="mt-3 mb-3"></v-divider>

    <v-layout wrap>
      <v-flex xs12 sm8>
        <div class="nav nav-tabs" style="margin-bottom:15px; overflow-x: auto; white-space: nowrap">
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('all')"
            :outline="filterStatus != 'all'"
            :color="filterStatus != 'all' ? 'grey' : 'primary'"
            >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('ordered')"
            :outline="filterStatus != 'ordered'"
            :color="filterStatus != 'ordered' ? 'grey' : 'primary'"
            >{{ $t('ordered') }} {{ badge.ordered > 0 ? '(' + badge.ordered + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('paid')"
            :outline="filterStatus != 'paid'"
            :color="filterStatus != 'paid' ? 'grey' : 'primary'"
            >{{ $t('paid') }} {{ badge.paid > 0 ? '(' + badge.paid + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('shipped')"
            :outline="filterStatus != 'shipped'"
            :color="filterStatus != 'shipped' ? 'grey' : 'primary'"
            >{{ $t('shipped') }} {{ badge.shipped > 0 ? '(' + badge.shipped + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('canceled')"
            :outline="filterStatus != 'canceled'"
            :color="filterStatus != 'canceled' ? 'grey' : 'primary'"
            >{{ $t('cancel') }} {{ badge.canceled > 0 ? '(' + badge.canceled + ')' : '' }}</v-btn
          >
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="text-xs-right">
        <v-layout justify-end>
          <print-all-covers-bearhouse
            :orders="filterOrders"
            @onPrinCover="onPrinCover(false, $event)"
          ></print-all-covers-bearhouse>
          <v-btn outline color="grey" @click="exportOrderSummary" class="mr-0">
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>

          <v-btn fab outline color="primary" @click="onRefresh" v-tooltip.top="$t('Refresh')" small>
            <i class="fa fa-refresh"></i>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12 sm4 class="form-control px-1 py-1">
        <input type="text" :placeholder="$t('Search')" v-model="search" />
      </v-flex>

      <v-flex xs12 sm4 px-1 py-1>
        <multiselect
          v-if="shippingOptions.length"
          label="name"
          v-model="shippingFilter"
          :options="filteredShipping"
          :placeholder="$t('Shipping')"
          track-by="value"
          :multiple="true"
        >
          <template slot="option" slot-scope="props">
            <span class="option__title"
              >{{ $t(props.option.name) }} ({{ props.option.count }})</span
            >
          </template>
        </multiselect>
      </v-flex>

      <v-flex xs12 sm4 class="text-xs-center text-sm-right px-1 py-1">
        <multiselect
          label="label"
          v-model="status"
          :disabled="!selected.length"
          :options="orderStatusOptions"
          :allow-empty="true"
          :searchable="false"
          :placeholder="$t('Modify all status')"
          selectLabel
          selectedLabel
          deselect-label
          @select="onSelectOrderStatus"
        ></multiselect>
      </v-flex>
    </v-layout>

    <v-data-table
      v-model="selected"
      select-all
      item-key="id"
      :headers="headers"
      :items="filterSummary"
      :pagination.sync="pagination"
      class="elevation-1"
      :loading="loading"
    >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll"
              color="primary"
            ></v-checkbox>
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : ''
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <bearhouse-order-item
          :key="props.item.id"
          v-model="props"
          @updateOrder="updateOrder(props.item.id, $event)"
          @onChangeStatus="onChangeStatus(props.item.id, $event)"
          @viewnote="viewnote(props.item.note)"
        ></bearhouse-order-item>
      </template>
    </v-data-table>
    <div style="height: 100px"></div>
    <v-dialog v-model="showNote" max-width="600">
      <v-card>
        <div class="text-xs-right">
          <v-btn flat fab small @click="showNote = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text v-if="note">
          <img :src="note" style="width: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'

import { bearhouseset } from '@/bearhouse.js'
import BearhouseOrderItem from './BearhouseOrderItem'
import XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'
import PrintAllCoversBearhouse from './PrintAllCoversBearhouse'

export default {
  data() {
    return {
      selected: [],
      pagination: {
        sortBy: 'id',
        descending: true
      },
      headers: [
        { text: this.$t('Order Number'), value: 'id' },
        { text: this.$t('Products'), sortable: false },
        { text: this.$t('Created Date'), value: 'timestamp' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Total'), value: 'total' },
        { text: this.$t('Product Price'), value: 'total' },
        { text: this.$t('Shipping Price'), value: 'shippingcharge' },
        { text: this.$t('quantity'), value: 'totalproduct' },
        { text: '', sortable: false },
        { text: this.$t('Payment Method'), value: 'payment' },
        { text: this.$t('Paid Date'), value: 'paiddate' },
        { text: this.$t('Paid Time'), value: 'paidtime' },
        { text: this.$t('Transaction ID'), value: 'transactionid' },
        { text: this.$t('Tracking'), value: 'trackingno' },
        { text: this.$t('Remark'), value: 'remark' },
        { text: this.$t('Social Name'), value: 'first_name' },
        { text: this.$t('Realname'), value: 'realname' },
        { text: 'เบอร์โทร', value: 'เบอร์โทร', sortable: false },
        { text: 'ตำบล', value: 'ตำบล', sortable: false },
        { text: 'อำเภอ', value: 'อำเภอ', sortable: false },
        { text: 'จังหวัด', value: 'จังหวัด', sortable: false },
        { text: 'รหัสไปรษณีย์', value: 'รหัสไปรษณีย์', sortable: false },
        { text: this.$t('Address'), value: 'nameaddress' },
        { text: this.$t('Tag'), value: 'tags' },
        { text: this.$t('Shipping Name'), value: 'shippingtype' },
        { text: 'ชานมบ้านหมีหน้าร้าน', value: 'ชานมบ้านหมีหน้าร้าน' },
        { text: 'ช็อกโกแลตบ้านหมี', value: 'ช็อกโกแลตบ้านหมี' },
        { text: 'ชาไทยบ้านหมีปักษ์ใต้', value: 'ชาไทยบ้านหมีปักษ์ใต้' },
        { text: 'ชาพีชบ้านหมี', value: 'ชาพีชบ้านหมี' },
        { text: 'ไข่มุกบุกคาราเมลไหม้', value: 'ไข่มุกบุกคาราเมลไหม้' },
        { text: 'โมจิโรลนมฮอกไกโด', value: 'โมจิโรลนมฮอกไกโด' },
        { text: 'โมจิโรลช็อกโกแลต ', value: 'โมจิโรลช็อกโกแลต' },
        { text: 'โมจิโรลฝอยทองบ้านหมี', value: 'โมจิโรลฝอยทองบ้านหมี' },
        { text: 'นมน้ำตาลแดงบ้านหมี ', value: 'นมน้ำตาลแดงบ้านหมี' },
        { text: 'ชาดำยูซุบ้านหมี', value: 'ชาดำยูซุบ้านหมี' },
        { text: 'แป้งไข่มุกโมจิบ้านหมี D.I.Y', value: 'แป้งไข่มุกโมจิบ้านหมี D.I.Y' },
        { text: 'ถุงผ้า 9 BEARS หมี 9 ตัว', value: 'ถุงผ้า 9 BEARS หมี 9 ตัว' },
        { text: 'ถุงผ้า BROWN BEAR หมีน้ำตาล', value: 'ถุงผ้า BROWN BEAR หมีน้ำตาล' },
        { text: 'ถุงผ้า BLUE BEAR หมีน้ำเงิน', value: 'ถุงผ้า BLUE BEAR หมีน้ำเงิน' },
        { text: 'ถุงผ้า WHITE BEAR หมีขาว', value: 'ถุงผ้า WHITE BEAR หมีขาว' },
        { text: 'พุดดิ้งสุขเย็นช็อกละมุน', value: 'พุดดิ้งสุขเย็นช็อกละมุน' },
        { text: 'พุดดิ้งสุขเย็นนมละมุน', value: 'พุดดิ้งสุขเย็นนมละมุน' },
        { text: 'เหมือนฝัน เปี๊ยะโมจิไก่หยอง', value: 'เหมือนฝัน เปี๊ยะโมจิไก่หยอง' },
        { text: 'เหมือนฝัน เปี๊ยะโมจิไข่เค็ม', value: 'เหมือนฝัน เปี๊ยะโมจิไข่เค็ม' }

        // { text: 'วันโอน', value: '' },
        // { text: 'เวลาโอน', value: '' }
      ],
      desserts: [],
      shippingFilter: [],
      shippingOptions: [],
      cbAll: [],
      checkboxAll: false,
      pageNumber: 1,
      size: 10,
      search: '',
      filterStatus: 'all',
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
      selectedDate: {
        start: moment()
          .startOf('month')
          .toDate(),
        end: moment()
          .endOf('month')
          .toDate()
      },
      summary: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      currentFilter: 'this_month',
      badge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      },
      status: '',
      orderStatusOptions: [
        {
          label: this.$t('ordered'),
          value: 'ordered'
        },
        {
          label: this.$t('paid'),
          value: 'paid'
        },
        {
          label: this.$t('shipped'),
          value: 'shipped'
        },
        {
          label: this.$t('cancel'),
          value: 'canceled'
        }
      ],
      showNote: false,
      note: null,
      loading: true
    }
  },
  components: {
    datepicker,
    BearhouseOrderItem,
    PrintAllCoversBearhouse,
    Multiselect
    // PrintAllCovers
  },
  computed: {
    filteredShipping() {
      let vm = this
      // console.log(vm.shippingOptions.map(el => {name: $t(el.name), value: el.name, count: vm.summary.filter( v => v.shippingtype == el.name).length}))
      return vm.shippingOptions.map(el => {
        return {
          name: vm.$t(el.name),
          value: el.name,
          count: vm.desserts.filter(v => v.shippingtype == el.name).length
        }
      })
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct'
    }),
    pageCount: function() {
      let l = this.badge[this.filterStatus]
      let s = this.size
      return Math.ceil(l / s)
    },
    filterSummary: function() {
      let vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.desserts
      } else {
        filter = vm.desserts.filter(function(el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter(el => {
          return vm.shippingFilter.some(v => el.shippingtype == v.value)
        })
      }

      vm.badge = {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      }
      vm.badge.all = filter.length

      $.each(filter, function(index, val) {
        vm.badge[val.status] += 1
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return orders
    },
    filterOrders: function() {
      let vm = this
      let orders = this.desserts
      if (this.selected.length > 0) {
        orders = this.selected
      } else if (vm.filterStatus !== 'all') {
        orders = this.desserts.filter(el => el.status == vm.filterStatus)
      }

      return orders
    }
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('loadProducts')
    await this.getShipping()
    await this.getOrderSummary()
    this.loading = false
  },
  methods: {
    async onRefresh() {
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    changeDate: function(value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment()
            .subtract(1, 'months')
            .toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment()
            .startOf('month')
            .toDate()
          vm.selectedDate.end = moment()
            .endOf('month')
            .toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment()
            .startOf('year')
            .toDate()
          vm.selectedDate.end = moment()
            .endOf('year')
            .toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment()
            .subtract(365, 'days')
            .toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'custom_date':
          break

        case 'custom_time':
          vm.onSelectedDate()
          break
      }
    },
    onSelectedDate: async function(value) {
      this.pageNumber = 1
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    onSelectedStartDate: async function(value) {
      this.pageNumber = 1
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
    },
    onSelectedEndDate: async function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
    },
    async loadSummary() {
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    async viewnote(note) {
      console.log(note)
      this.note = note
      await this.$nextTick()
      this.showNote = true
    },
    updateOrder: function(id, payload) {
      let vm = this
      return new Promise(resolve => {
        vm.$store.dispatch('loading')
        let data = vm.desserts.find(function(element) {
          return element.id === id
        })
        if (payload == 'send' && data.status == 'canceled') {
          data.sendreason = true
        }
        if (data) {
          api.editOrderSummary(data, function(error, response) {
            if (error) {
              console.error(error)
              vm.$store.dispatch('loading')
              return
            }
            vm.$store.dispatch('loading')
            resolve()
          })
        }
      })
    },
    onChangeStatus: function(id, status) {
      let vm = this
      var select = [id]
      if (select.length > 0) {
        let data = {
          status: status.value,
          orderid: select,
          pageid: this.selectedBot.pageid
        }
        api.putmultistatusordersummary(data, function(error, response) {
          if (error) {
            vm.status = ''
            return console.error(error)
          }
          vm.desserts.forEach(el => {
            if (select.includes(el.id)) el.status = status.value
          })
          vm.status = ''
        })
      }
    },
    onSelectOrderStatus(status) {
      let vm = this
      var select = this.selected.map(el => {
        return el.id
      })
      if (select.length > 0) {
        let data = {
          status: status.value,
          orderid: select,
          pageid: this.selectedBot.pageid
        }
        api.putmultistatusordersummary(data, function(error, response) {
          if (error) {
            vm.status = ''
            return console.error(error)
          }
          vm.desserts.forEach(el => {
            if (select.includes(el.id)) el.status = status.value
          })
          vm.status = ''
        })
      }
    },
    getShipping() {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = { pageid: vm.selectedBot.pageid }
        api.getAllShipingCharge(data, (error, response) => {
          if (error) reject(error)

          let result = Object.keys(response.shippinglist).map(function(key) {
            return { name: key, ...response.shippinglist[key] }
          })

          vm.shippingOptions = result
          resolve()
        })
      })
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.filterSummary.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    getOrderSummary: function() {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          datefrom:
            moment(vm.selectedDate.start).format('YYYY-MM-DD') +
            (vm.starttime != null ? ' ' + vm.starttime : ''),
          dateto:
            moment(vm.selectedDate.end).format('YYYY-MM-DD') +
            (vm.endtime != null ? ' ' + vm.endtime : ''),
          status: vm.filterStatus
        }
        // vm.$store.dispatch('loading')
        api.getOrderSummary(data, function(error, response) {
          if (error) {
            console.error(error)
            // vm.$store.dispatch('loading')
            reject()
          }
          if (response.data) {
            vm.summary = response.data
            var data = []
            response.data.map(el => {
              var count = 0
              var record = el
              var productdetail = []
              record['ชานมบ้านหมีหน้าร้าน'] = 0
              record['ช็อกโกแลตบ้านหมี'] = 0
              record['ชาไทยบ้านหมีปักษ์ใต้'] = 0
              record['ชาพีชบ้านหมี'] = 0
              record['ไข่มุกบุกคาราเมลไหม้'] = 0
              record['โมจิโรลนมฮอกไกโด'] = 0
              record['โมจิโรลช็อกโกแลต'] = 0
              record['โมจิโรลฝอยทองบ้านหมี'] = 0
              record['นมน้ำตาลแดงบ้านหมี'] = 0
              record['แป้งไข่มุกโมจิบ้านหมี D.I.Y'] = 0
              record['ถุงผ้า 9 BEARS หมี 9 ตัว'] = 0
              record['ถุงผ้า BROWN BEAR หมีน้ำตาล'] = 0
              record['ถุงผ้า BLUE BEAR หมีน้ำเงิน'] = 0
              record['ถุงผ้า WHITE BEAR หมีขาว'] = 0
              record['ชาดำยูซุบ้านหมี'] = 0
              record['พุดดิ้งสุขเย็นช็อกละมุน'] = 0
              record['พุดดิ้งสุขเย็นนมละมุน'] = 0
              record['เหมือนฝัน เปี๊ยะโมจิไก่หยอง'] = 0
              record['เหมือนฝัน เปี๊ยะโมจิไข่เค็ม'] = 0

              try {
                var productlist = JSON.parse(record.productdetail)

                productlist.map(product => {
                  if (bearhouseset.hasOwnProperty(product.name.trim())) {
                    var set = bearhouseset[product.name.trim()]
                    var subproduct = []
                    set.map(pid => {
                      var p = vm.products.find(el => {
                        return el.id == pid
                      })
                      if (p) {
                        var photo = p.photourl.split(',')
                        let pIndex = subproduct.findIndex(pd => {
                          return pd.name == p.name
                        })
                        if (pIndex > -1) {
                          subproduct[pIndex].quantity += product.quantity
                        } else {
                          subproduct.push({
                            name: p.name,
                            quantity: product.quantity,
                            option: p.productstock.length > 0 ? p.productstock[0][1] : '',
                            sku: p.productstock.length > 0 ? p.productstock[0][5] : '',
                            price:
                              p.productstock.length > 0 ? p.productstock[0][4] : p.discountprice,
                            photourl: photo.length > 0 ? photo[0] : ''
                          })
                        }
                        count += product.quantity
                      }
                    })
                    let pIndex = productdetail.findIndex(pd => {
                      return pd.name == product.name
                    })
                    if (pIndex > -1) {
                      productdetail[pIndex].quantity += 1
                    } else {
                      product.subproduct = subproduct
                      productdetail.push(product)
                    }
                  } else {
                    let pIndex = productdetail.findIndex(pd => {
                      return pd.name == product.name
                    })
                    if (pIndex > -1) {
                      productdetail[pIndex].quantity += 1
                    } else {
                      productdetail.push(product)
                    }
                    count += product.quantity
                  }
                })
              } catch (error) {
                console.error(error)
                productdetail = record.productdetail
              }

              if (typeof productdetail === 'object') {
                productdetail.map(p => {
                  if (record.hasOwnProperty(p.name.trim())) {
                    record[p.name.trim()] += parseInt(p.quantity)
                  }
                  if (p.subproduct) {
                    p.subproduct.map(el => {
                      if (record.hasOwnProperty(el.name.trim())) {
                        record[el.name.trim()] += parseInt(el.quantity)
                      }
                    })
                  }
                })
              }

              var realname_group = record.nameaddress ? record.nameaddress.split(',') : []
              var realname = realname_group.length > 0 ? realname_group[0] : ''
              record.realname = realname
              record.paidtime = record.paiddate ? moment(record.paiddate).format('HH:mm') : '-'

              record.productlist = productdetail
              record.totalproduct = count
              //   {"name":"โมจิโรลนมฮอกไกโด","quantity":"1","option":"Normal","sku":"","price":"120","photourl" : "https://d25bondvihbdz.cloudfront.net/ecommerce/1586108442478S__87241566.jpg"}
              data.push(record)
            })

            vm.desserts = data

            //    { text: 'Order No.', value: '' },
            // { text: 'Products', value: '' },
            // { text: 'ชานมบ้านหมี', value: '' },
            // { text: 'ชาไทยบ้านหมีปักษ์ใต้', value: '' },
            // { text: 'ช็อคโกแลตบ้านหมี', value: '' },
            // { text: 'นมน้ำตาลแดงบ้านหมี', value: '' },
            // { text: 'ไข่มุกขุกคาราเมลไหม้', value: '' },
            // { text: 'โมจิโรลนมฮอกไกโด ', value: '' },
            // { text: 'โมจิโรลช็อคโกแลต', value: '' },
            // { text: 'โมจิโรลฝอยทอง ', value: '' },
            // { text: 'remark', value: '' }

            if (vm.filterStatus == 'all') {
              vm.badge = {
                all: response.all,
                canceled: response.canceled,
                ordered: response.ordered,
                paid: response.paid,
                shipped: response.shipped
              }
            }
          }
          resolve()
          // vm.$store.dispatch('loading')
        })
      })
    },
    changeStatus: function(value) {
      this.filterStatus = value
      this.pageNumber = 1
    },
    exportOrderSummary: function(type) {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.desserts
      } else {
        filter = vm.desserts.filter(function(el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      $.each(filter, function(index, val) {
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      var json = []
      orders.map(val => {
        let productlist = ''

        val.productlist.map(p => {
          productlist +=
            p.name +
            ' x ' +
            p.quantity +
            ` SKU:${p.sku ? p.sku : '- '}` +
            (p.option ? ' (' + p.option + ')' : '') +
            ' : ' +
            (p.price > 0 ? '฿' + p.price : 'Free') +
            '\n'
          if (p.subproduct) {
            p.subproduct.map(sub => {
              productlist +=
                ' - ' +
                sub.name +
                ' x ' +
                sub.quantity +
                ` SKU:${sub.sku ? sub.sku : '- '}` +
                (sub.option ? ' (' + sub.option + ')' : '') +
                ' : ' +
                (sub.price > 0 ? '฿' + sub.price : 'Free') +
                '\n'
            })
          }
        })
        var realname_group = val.nameaddress ? val.nameaddress.split(',') : []
        var realname = realname_group.length > 0 ? realname_group[0] : ''
        var payment = vm.$t('Credit card')
        if (val.payment == 'banktransfer' || val.payment == 'transfer') {
          payment = vm.$t('Bank Transfer')
        } else if (val.payment == 'qrcode') {
          payment = 'Qr Code'
        } else if (val.payment == 'fbpay') {
          payment = vm.$t('Mobile Banking')
        } else if (val.payment == 'cod') {
          payment = vm.$t('cod_charge')
        }

        let address = val.nameaddress ? val.nameaddress.split(' , ') : null
        json.push({
          orderno: val.id,
          products: productlist,
          'Created Date': val.timestamp,
          Status: val.status,
          Tags: val.tags,
          Quantity: val.totalproduct,
          Payment: payment,
          'Paid Date': val.paiddate ? moment(val.paiddate).format('DD/MM/YYYY') : '-',
          'Paid Time': val.paiddate ? moment(val.paiddate).format('HH:mm') : '-',
          'Transaction ID': val.transactionid,
          tackingno: val.trackingno,
          remark: val.remark,
          socialname: `${val.first_name} ${val.last_name}`,
          realname: realname,
          เบอร์โทร: address && address.length > 0 && address[7] ? address[7] : '-',
          ตำบล: address && address.length > 0 && address[3] ? address[3] : '-',
          อำเภอ: address && address.length > 0 && address[4] ? address[4] : '-',
          จังหวัด: address && address.length > 0 && address[5] ? address[5] : '-',
          รหัสไปรษณีย์: address && address.length > 0 && address[6] ? address[6] : '-',
          address: val.nameaddress,
          total: val.amount,
          ค่าสินค้า: numeral(parseFloat(val.total) - parseFloat(val.shippingcharge)).format(
            '0,0.00'
          ),
          ค่าขนส่ง: val.shippingcharge,
          shipping: this.$t(val.shippingtype),
          ชานมบ้านหมีหน้าร้าน: val['ชานมบ้านหมีหน้าร้าน'],
          ช็อกโกแลตบ้านหมี: val['ช็อกโกแลตบ้านหมี'],
          ชาไทยบ้านหมีปักษ์ใต้: val['ชาไทยบ้านหมีปักษ์ใต้'],
          ชาพีชบ้านหมี: val['ชาพีชบ้านหมี'],
          ไข่มุกบุกคาราเมลไหม้: val['ไข่มุกบุกคาราเมลไหม้'],
          โมจิโรลนมฮอกไกโด: val['โมจิโรลนมฮอกไกโด'],
          โมจิโรลช็อกโกแลต: val['โมจิโรลช็อกโกแลต'],
          โมจิโรลฝอยทองบ้านหมี: val['โมจิโรลฝอยทองบ้านหมี'],
          นมน้ำตาลแดงบ้านหมี: val['นมน้ำตาลแดงบ้านหมี'],
          ชาดำยูซุบ้านหมี: val['ชาดำยูซุบ้านหมี'],
          'แป้งไข่มุกโมจิบ้านหมี D.I.Y': val['แป้งไข่มุกโมจิบ้านหมี D.I.Y'],
          'ถุงผ้า 9 BEARS หมี 9 ตัว': val['ถุงผ้า 9 BEARS หมี 9 ตัว'],
          'ถุงผ้า BROWN BEAR หมีน้ำตาล': val['ถุงผ้า BROWN BEAR หมีน้ำตาล'],
          'ถุงผ้า BLUE BEAR หมีน้ำเงิน': val['ถุงผ้า BLUE BEAR หมีน้ำเงิน'],
          'ถุงผ้า WHITE BEAR หมีขาว': val['ถุงผ้า WHITE BEAR หมีขาว'],
          พุดดิ้งสุขเย็นช็อกละมุน: val['พุดดิ้งสุขเย็นช็อกละมุน'],
          พุดดิ้งสุขเย็นนมละมุน: val['พุดดิ้งสุขเย็นนมละมุน'],
          'เหมือนฝัน เปี๊ยะโมจิไก่หยอง': val['เหมือนฝัน เปี๊ยะโมจิไก่หยอง'],
          'เหมือนฝัน เปี๊ยะโมจิไข่เค็ม': val['เหมือนฝัน เปี๊ยะโมจิไข่เค็ม']
        })
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'export.xlsx')
    }
  },
  watch: {
    search: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageNumber = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/BearhouseOrder.vue